import { memo } from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext";
import { plansTitleList } from "../../../../../utils/jumbomailSettings";
import GetTransformedDate from "../../../../../utils/dateViewTransformer";
import { useUser } from "../../../../../contexts/userContext/userContext";
import type { PurchaseParamsT, SubscriptionT } from "../../models/models";
import { useParams } from "react-router-dom";
import useDowngrade from "../../hooks/useDowngrade";
import { PackagePeriodsE } from "../../models/enums";

import styles from "./styles.module.scss";

const PurchaseComparePlansSection = memo(() => {
  const { packageType, periodType } = useParams<PurchaseParamsT>();
  const { getTextByKey } = useContent();
  const { getUserBillingDetails, isSubscribed } = useUser();
  const billingDetails = getUserBillingDetails() as SubscriptionT;
  const { isDowngrade } = useDowngrade();

  const dateToDisplay =
    billingDetails?.nextPaymentDate || billingDetails?.endDate;

  const isPlanPurchase =
    packageType === "pro" ||
    packageType === "business" ||
    packageType === "premium";

  const isShown = !!billingDetails && isPlanPurchase && isSubscribed();

  if (!isShown) return <></>;

  return (
    <div className={styles.purchaseComparePlansSection}>
      <div className={styles.purchaseComparePlansContainer}>
        <div className={`${styles.comparePlanPart} ${styles.currentPlan}`}>
          <div className={styles.comparePlanPartTitle}>
            <h5>{getTextByKey("current-plan-title")}</h5>
          </div>
          <div className={styles.comparePlanPartBody}>
            <span className={styles.planType}>
              {plansTitleList[billingDetails?.type]}
            </span>
            <span className={styles.planPeriod}>
              {getTextByKey(
                billingDetails?.auto_renew
                  ? "next-billing-date-purchase"
                  : "valid-until"
              )}{" "}
              <GetTransformedDate
                date={dateToDisplay}
                showDay={false}
                fullView
              />
            </span>
          </div>
        </div>
        <div className={`${styles.comparePlanPart} ${styles.newPlan}`}>
          <div className={styles.comparePlanPartTitle}>
            <h5>{getTextByKey("new-selected-plan")}</h5>
          </div>
          <div className={styles.comparePlanPartBody}>
            {
              <span className={styles.planType}>
                {plansTitleList[packageType as keyof typeof plansTitleList]}
              </span>
            }
            <span className={styles.planPeriod}>
              {getTextByKey(periodType + "-subscription")}
            </span>
          </div>
        </div>
      </div>
      {(packageType === "sub-users" || packageType === "extra-storage") &&
      !isDowngrade &&
      billingDetails?.period === PackagePeriodsE.MONTHLY ? (
        <div className={styles.upgradeText}>
          {getTextByKey("first-month-calc-price")}
        </div>
      ) : null}
    </div>
  );
});

export default PurchaseComparePlansSection;
